<template>
  <transition name="fade"
              mode="out-in"
              appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  methods: {
    setI18n () {
      this.$i18n.locale = this.isZh_CN ? 'zh_CN' : 'en'
    }
  },
  computed: {
    isZh_CN () {
      const { search } = window.location
      return search.indexOf('zh_CN') > -1
    }
  },
  mounted () {},
  created () {
    this.setI18n()
    this.$store.dispatch('home/asyncSetLanguage')
  },
  components: {}
}
</script>

<style src="../styles/app.css"></style>
<style src="../ui/styles/style.css"></style>
<style src="../ui/styles/jquery.fullPage.css"></style>



// WEBPACK FOOTER //
// root.vue?3f841403